<template>
  <div>
    <v-dialog v-model="showAbortMotivationDialog" width="500">
      <v-card>
        <v-card-title
          ><div class="headline">Passage en abandon</div></v-card-title
        >
        <v-card-text>
          <p>Quelle est la raison de l'abandon ?</p>
          <v-textarea
            v-model="abortMotivation"
            label="Pour quelle raison ?"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="d-flex d-flex-initial justify-end">
          <v-btn flat>Annuler</v-btn>
          <v-btn
            color="primary"
            :disabled="abortMotivation === null"
            @click="setAbort"
            >Valider</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap class="mt-2">
      <v-flex xs12 lg6>
        <FormLine
          :item="{
            items: progresses,
            value: () => announcement.currentProgress,
            as: 'select',
            name: 'progress',
            label: 'Statut',
          }"
          @input="onProgressUpdate($event)"
          :edit-mode="editMode"
        ></FormLine>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex lg6 xs12>
        <h3 class="ml-3">Informations sur l'annonce</h3>
        <template v-for="item in infos">
          <FormLine
            :item="item"
            v-model="announcement"
            :key="item.name"
            :edit-mode="editMode"
          ></FormLine>
          <v-divider :key="`${item.name}-divider`" />
        </template>
        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title>Description : </v-list-tile-title>
            <v-textarea
              v-model="announcement.description"
              style="width: 100%"
            ></v-textarea>
          </v-list-tile-content>
        </v-list-tile>
      </v-flex>
      <v-flex lg6 xs12>
        <h3 class="ml-3">Contact</h3>
        <template v-for="item in contact">
          <FormLine
            :item="item"
            v-model="announcement"
            :key="item.name"
            :edit-mode="editMode"
          ></FormLine>
          <v-divider :key="`${item.name}-divider`" />
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { ALL_ANNOUNCEMENTS_COLUMNS } from "../../data/DefaultSettings";
import FormLine from "../commons/FormLine.vue";

export default {
  props: ["announcement", "editMode", "fieldsGetter"],
  components: {
    FormLine,
  },
  inject: ["$validator"],
  data() {
    return {
      ...this.fieldsGetter.apply(this),
      abortMotivation: "",
      showAbortMotivationDialog: false,
    };
  },
  methods: {
    ...mapActions("comments", ["fetchComments", "pushComment"]),

    onProgressUpdate(step) {
      if (step.progress === "stopped") {
        this.showAbortMotivationDialog = true;
      } else {
        this.announcement.currentProgress = step.progress;
      }

      this.$forceUpdate();
    },
    setAbort() {
      this.announcement.currentProgress = "stopped";
      this.showAbortMotivationDialog = false;
      this.pushComment({
        content: `Abandonné car "${this.abortMotivation}"`,
        targetId: this.announcement._id,
        extraAttributes: {
          visibility: "sales",
        },
      });
      this.abortMotivation = "";

      this.$forceUpdate();
    },
  },
  computed: {
    progresses() {
      return ALL_ANNOUNCEMENTS_COLUMNS.map((c, i) => ({
        ...c,
        text: `[${i < 10 ? `0${i}` : i}] ${c.text}`,
      }));
    },
  },
};
</script>

<style scoped>
.no-clamp {
  -webkit-line-clamp: 1000 !important;
}

.fsz {
  font-size: 12px !important;
}

.general-hints {
  color: #555;
  margin-left: 30px;
  margin-bottom: 24px;
}
</style>
